{
  "columnResizer": "Stulpelio dydžio keitiklis",
  "loading": "Įkeliama...",
  "loadingMore": "Įkeliama daugiau...",
  "resizeColumn": "Keisti stulpelio dydį",
  "sortAscending": "Rikiuoti didėjimo tvarka",
  "sortDescending": "Rikiuoti mažėjimo tvarka"
}
